import { useTranslation } from 'react-i18next';

import { useThemeStore, type ThemeMode } from '@/stores/theme';

export default function ThemeToggle() {
  const { t } = useTranslation();
  const { mode, setMode } = useThemeStore();
  const options: Array<{ value: ThemeMode; labelKey: string; icon: string }> = [
    { value: 'light', labelKey: 'theme.light', icon: '☀' },
    { value: 'dark', labelKey: 'theme.dark', icon: '🌙' },
    { value: 'system', labelKey: 'theme.system', icon: '🖥' },
  ];
  return (
    <div className="flex gap-2">
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          onClick={() => setMode(o.value)}
          className={`btn-outline text-xs flex-1 ${
            mode === o.value
              ? 'bg-brand-50 text-brand-700 border-brand-300 dark:bg-brand-900/30 dark:text-brand-300 dark:border-brand-700'
              : ''
          }`}
        >
          <span className="mr-1">{o.icon}</span>
          {t(o.labelKey)}
        </button>
      ))}
    </div>
  );
}
